// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TasksMoveModal from './data'

export default function TasksMoveModalFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TasksMoveModal">
      <TasksMoveModal {...props}>
        {children}
      </TasksMoveModal>
    </Flow>
  )
}
